import { z } from 'zod';
import { Validation } from '@mews/framework';

export enum FiltersValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
}

export const filtersSchema = z
    .object({
        [FiltersValueKey.startDate]: z.union([Validation.Date.Iso, z.literal('')]).optional(),
        [FiltersValueKey.endDate]: z.union([Validation.Date.Iso, z.literal('')]).optional(),
    })
    .partial();

export type LedgerActivityReportFilterValues = z.infer<typeof filtersSchema>;

export const defaultLedgerActivityReportFilterValues = {
    [FiltersValueKey.startDate]: '',
    [FiltersValueKey.endDate]: '',
};
